const post = {
    id: 'va-urma',
    title: 'Va urma',
    date: '2026-08-09',
    readTime: '2 minute de citit',
    excerpt: 'Această pagină de blog va fi dezvoltată în curând...',
    tags: ['profesor', 'inginer', 'informatica', 'tic'],
    cover: null,
    content: `
        Această pagină de blog va fi dezvoltată în curând...
    `,
};

export default post;